import { Directive, Input } from '@angular/core';
import { Base64EncodedString } from '../../models';

@Directive()
export class PdfOverViewBaseComponent {
  @Input() name: string;
  @Input() size: Base64EncodedString;
  @Input() className?: string;
  @Input() length?: number;
  @Input() index?: number;
}
